import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateClaim from "./CreateClaim";
import UserService from "services/UserService";
import axios from "axios";
import { getMarketMembershipClaims } from "services/ConfigServices";
import { memberclaimStatusData } from "variables/lists/markets";
import { memberclaim } from "variables/markets";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useClaimTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const markets_admin = permis.includes("markets_admin");
  const markets_update = permis.includes("markets_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMarketMembershipClaims(chartIdGroup, market.id);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedClaims, setSelectedClaims] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );


  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        <CreateClaim refetch={refreshTable} onClick={onUpload} />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(results, `claims`, []).filter(
    (item) =>
      (item.parameters.purpose && item.parameters.purpose.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.amountasked && item.parameters.amountasked.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.amountreceived && item.parameters.amountreceived.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && memberclaimStatusData.find((x) => x.id == item.parameters.status) && memberclaimStatusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.author && item.parameters.author.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.marketmembershipnumber && item.parameters.marketmembershipnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.marketmembershipname && item.parameters.marketmembershipname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.enddate && moment(item.parameters.enddate).isValid() && moment(item.parameters.enddate).format("DD/MM/YYYY HH:mm").includes(filterText)) ||
      (item.parameters.creationdate && moment(item.parameters.creationdate).isValid() && moment(item.parameters.creationdate).format("DD/MM/YYYY").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedClaims.map((item) => {
      let claimtoexport = {};
      claimtoexport[memberclaim.purpose] = item.parameters.purpose;
      claimtoexport[memberclaim.amountasked] = item.parameters?.amountasked && new Intl.NumberFormat('fr-FR', {useGrouping: false, maximumFractionDigits: 2 }).format(item.parameters?.amountasked);
      claimtoexport[memberclaim.amountreceived] = item.parameters.amountreceived && new Intl.NumberFormat('fr-FR', {useGrouping: false, maximumFractionDigits: 2 }).format(item.parameters?.amountreceived);
      claimtoexport[memberclaim.status] = memberclaimStatusData.find((x) => x.id == item.parameters.status)?.name;
      claimtoexport[memberclaim.author] = item.parameters.author;
      claimtoexport[memberclaim.marketmembershipnumber] = item.parameters.marketmembershipnumber;
      claimtoexport[memberclaim.marketmembershipname] = item.parameters.marketmembershipname;
      claimtoexport[memberclaim.creationdate] = (item.parameters.creationdate && moment(item.parameters.creationdate).isValid()) ? moment(item.parameters.creationdate).format("DD/MM/YYYY HH:mm") : "";
      claimtoexport[memberclaim.validationdate] = (item.parameters.validationdate && moment(item.parameters.validationdate).isValid()) ? moment(item.parameters.validationdate).format("DD/MM/YYYY") : "";
      claimtoexport[memberclaim.enddate] = (item.parameters.enddate && moment(item.parameters.enddate).isValid()) ? moment(item.parameters.enddate).format("DD/MM/YYYY") : "";
      claimtoexport[memberclaim.detail] = item.parameters.detail && item.parameters.detail.replaceAll("\n", " ");
      claimtoexport[memberclaim.rejectioncause] = item.parameters.rejectioncause && item.parameters.rejectioncause.replaceAll("\n", " ");
      return claimtoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {markets_update && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateClaim refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
         <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedClaims || selectedClaims.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedClaims]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedClaims
  };
}
